import { render, staticRenderFns } from "./RoundMemberWinLose.vue?vue&type=template&id=685b2096&"
import script from "./RoundMemberWinLose.vue?vue&type=script&lang=js&"
export * from "./RoundMemberWinLose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports